export default __webpack_public_path__ + "static/media/rocketfid.7b2a8bc1.png";